import {Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {fromEvent, Subscription, throttleTime} from "rxjs";
import {filter} from "rxjs/operators";
import {MatIcon} from "@angular/material/icon";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.scss'],
  standalone: true,
  imports: [
    MatIcon,
    RouterLink
  ]
})
export class NavHeaderComponent implements OnInit, OnDestroy{
  isOpen = false;
  resize!: Subscription;
  @ViewChild('el') elementRef!: ElementRef;
  ngOnInit() {
    /**
     * Although the application doesn't use this.resize. it is used for unsubscribing (memory cleanup)
     */
    this.resize = fromEvent(window, "resize")
      .pipe(
        throttleTime(500),
        filter(() => !!this.elementRef)
      )
      .subscribe(() => this.checkIfNavDropDown());
  }

  ngOnDestroy() {
    /**
     * It's a good habit to unsubscribe from observable event to prevent memory leak. If your application create
     * streams without cleaning up it can be a memory hog and will eventually crash.
     */
    this.resize.unsubscribe();
  }
  /**
   * Listens for a click in document and then check for isOpen to be true.
   * If so, then close it
   */
  @HostListener("document:click", ["$event"]) onClick(event:any) {
    if (!this.elementRef?.nativeElement.contains(event.target)) {
      this.checkIfNavDropDown();
    }
  }
  checkIfNavDropDown() {
    if (this.isOpen) {
      this.isOpen = false;
    }
  }

  onMenu() {
    this.isOpen = !this.isOpen;
  }
}
